import { sendRequest } from "../sendRequest";

export const withdrawMoney = ({ fundAccountId, price }) => {
  return sendRequest("post", "/influencer/wallet/withdraw", {
    fundAccountId,
    amount: price,
  }).then((res) => res.data);
};
